import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { API, COLLECTIONS } from "../lib/constants";

const ShopContext = createContext(null);
export const useShop = () => useContext(ShopContext);

export const ShopProvider = ({ children }) => {
  const [perfumes, setPerfumes] = useState([]);
  const [collections, setCollections] = useState(COLLECTIONS);
  const [settings, setSettings] = useState({ whatsapp_number: "", referral_link: "", contact_email: "" });
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    axios
      .all([axios.get(`${API}/perfumes`), axios.get(`${API}/settings`), axios.get(`${API}/collections`)])
      .then(
        axios.spread((p, s, c) => {
          setPerfumes(Array.isArray(p.data) ? p.data : []);
          setSettings(s.data || {});
          if (Array.isArray(c.data) && c.data.length) setCollections(c.data);
        })
      )
      .catch((e) => console.error("Shop load error:", e));
  }, []);

  useEffect(() => {
    if (selected) {
      document.body.style.overflow = "hidden";
      window.__lenis?.stop?.();
    } else {
      document.body.style.overflow = "";
      window.__lenis?.start?.();
    }
  }, [selected]);

  const openPerfume = useCallback((p) => setSelected(p), []);
  const closePerfume = useCallback(() => setSelected(null), []);

  const value = useMemo(
    () => ({ perfumes, collections, settings, selected, openPerfume, closePerfume }),
    [perfumes, collections, settings, selected, openPerfume, closePerfume]
  );

  return <ShopContext.Provider value={value}>{children}</ShopContext.Provider>;
};
